import { jsx as _jsx } from "react/jsx-runtime";
import { addSuccessNotification, addWarningNotification, cancelCurrentMemberSubscription, NotificationType } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { MemberSubscriptionStatus } from '@vista-digital/ocapi-types/v1';
import { observer } from 'mobx-react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { ConfirmationModal } from '../../../../subcomponents/confirmation-modal/confirmation-modal';
import { getIdForComponentNotification } from '../../../../utils/get-id-for-component-notification';
const b = bemClassBuilder('v-member-subscription-cancellation-modal');
export const MemberSubscriptionCancellationModal = observer(props => {
    const i18n = useI18n();
    const { show, onClose, endDate, subscriptionStatus, displayText } = props;
    const onConfirmCancellation = async () => {
        try {
            await cancelCurrentMemberSubscription();
            addSuccessNotification({
                id: getIdForComponentNotification('member-subscription-cancellation', NotificationType.Success, 'subscription-cancellation'),
                messages: getSuccessfulNotificationMessage()
            });
        }
        catch (error) {
            addWarningNotification({
                id: getIdForComponentNotification('member-subscription-cancellation', NotificationType.Error, 'subscription-cancellation'),
                messages: [displayText.failedToCancelSubscriptionMessage]
            });
        }
        finally {
            onClose();
        }
    };
    const getSuccessfulNotificationMessage = () => {
        const message = subscriptionStatus === MemberSubscriptionStatus.Frozen
            ? displayText.successfullyCancelledFromFrozenSubscriptionMessage
            : i18n.displayTextLabel(displayText.successfullyCancelledSubscriptionMessage, {
                endDate
            });
        return [message];
    };
    const getDescription = () => {
        return subscriptionStatus === MemberSubscriptionStatus.Frozen
            ? displayText.cancellationFromFrozenSubscriptionModalMessage
            : i18n.displayTextLabel(displayText.cancellationModalMessage, {
                endDate
            });
    };
    return (_jsx(ConfirmationModal, { className: b.block(), show: show, heading: displayText.cancellationModalHeading, message: getDescription(), acceptLabel: displayText.cancellationModalConfirmButtonLabel, cancelLabel: displayText.cancellationModalCloseButtonLabel, onCancel: onClose, onAccept: onConfirmCancellation }));
});
MemberSubscriptionCancellationModal.displayName = 'MemberSubscriptionCancellationModal';
